import { render, staticRenderFns } from "./form-placeholder.vue?vue&type=template&id=5d95e927"
import script from "./form-placeholder.vue?vue&type=script&lang=js"
export * from "./form-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports